
export enum GROUP_ICON {
	"ANIMAL FAT" = "assets/img/icons/switch-lp/Animal fat.svg",
	"CEREALS" = "assets/img/icons/switch-lp/Cereals.svg",
	"BAKERY" = "assets/img/icons/switch-lp/Bakery.svg",
	"VEGETABLES" = "assets/img/icons/switch-lp/Vegetables.svg",
	"PASTA&RICE" = "assets/img/icons/switch-lp/Pasta.svg",
	"LEGUMES" = "assets/img/icons/switch-lp/Legumes.svg",
	"FRUIT" = "assets/img/icons/switch-lp/Fruit.svg",
	"DAIRY" = "assets/img/icons/switch-lp/Dairy.svg",
	"MEAT" = "assets/img/icons/switch-lp/Meat.svg",
	"FISH" = "assets/img/icons/switch-lp/Fish-1.svg",
	"SHELLFISH" = "assets/img/icons/switch-lp/Shellfish.svg",
	"FISH&SHELLFISH" = "assets/img/icons/switch-lp/Fish.svg",
	"EGGS" = "assets/img/icons/switch-lp/Eggs.svg",
	"OILS&FAT" = "assets/img/icons/switch-lp/Oil.svg",
	"OILS&VEGETABLE FAT" = "assets/img/icons/switch-lp/Oil.svg",
	"NUTS&SEEDS" = "assets/img/icons/switch-lp/Nuts.svg",
	"SUGAR&HONEY&SWEETS" = "assets/img/icons/switch-lp/Sugar.svg",
	"DRESSING" = "assets/img/icons/switch-lp/Dressing.svg",
	"COFFEE&COCOA&TEA&INFUSES" = "assets/img/icons/switch-lp/Coffee.svg",
	"SOFT DRINKS" = "assets/img/icons/switch-lp/Soft_drinks.svg",
	"VEGETABLES MILK&PROTEINS" = "assets/img/icons/switch-lp/Vegetalbes_milk.svg",
	"WINE&BEER" = "assets/img/icons/switch-lp/Wine.svg",
	"SPICES" = "assets/img/icons/switch-lp/Spices.svg",
	"PLANT BASED MILK&PROTEINS"= "assets/img/icons/switch-lp/plant based.svg"
	
}

export class Group {
	id: any;
	uuid?: any;
	secureId?: string;
	icon?: string;
	items: GroupItem[];
	subgroups: Group[];
}
export class GroupItem {
	id;
	uuid;
	"FOOD COMMODITY GROUP";
	"FOOD COMMODITY SUB-GROUP";
	"FOOD COMMODITY ITEM";
	carbonFootprint;
	unitsCarbonFootprint;
	waterFootprint;
	unitsWaterfootprint;
	carbonFootprintBanding; 
	carbonFootprintBandingImpactDescription;
	waterFootprintBanding;
	waterFootprintBandingImpactDescription;
	blueSustainabilityIndex;
	environmentalScore;
	FATTY_or_LEAN_fish;
	energy;
	proteins;
	fat;
	saturatedFat;
	monounsaturatedFat;
	polyunsaturatedFat;
	carbohydrates;
	soluble;
	fiber;
	frequencyOfConsumption;
	recommendation?;
	Recommendation_on_Sustainability_and_Nutritional?;
}

export class Recipe {
	id?: any;
	recipeName: string;
	ingrediants: ReceiptItem[] = [];
	servings: number = 1;
	envScoreClass: string;
	recipeLink?: string;
}

export class ReceiptItem extends GroupItem {
	label;
	quantity;
	measurementUnit;
}

export class ReceipeDTO {
	id: any;
	recipeName: string;
	ingrediants: ReceiptItemDTO[] = [];
	servings: number;
	envScoreClass: string;
	recipeLink?: string;
}

export class ReceiptItemDTO {
	groupId;
	subgroupId;
	itemId;
	label;
	quantity;
	measurementUnit;
}

export class MealPlanItem {
	recipeNameLunch;
	recipeIdLunch;
	recipeClassLunch;
	recipeNameDinner;
	recipeIdDinner;
	recipeClassDinner;
	
}
export class MealPlan {
	id?: any;
	planName: string;
	lastUpdate: any;
	monday: MealPlanItem[] = [new MealPlanItem(),new MealPlanItem(),new MealPlanItem()];
	tuesday: MealPlanItem[] = [new MealPlanItem(),new MealPlanItem(),new MealPlanItem()];
	wednesday: MealPlanItem[] = [new MealPlanItem(),new MealPlanItem(),new MealPlanItem()];
	thursday: MealPlanItem[] = [new MealPlanItem(),new MealPlanItem(),new MealPlanItem()];
	friday: MealPlanItem[] = [new MealPlanItem(),new MealPlanItem(),new MealPlanItem()];
	saturday: MealPlanItem[] = [new MealPlanItem(),new MealPlanItem(),new MealPlanItem()];
	sunday: MealPlanItem[] = [new MealPlanItem(),new MealPlanItem(),new MealPlanItem()];
}

export class MealPlanItemDTO {
	recipeIdLunch;
	recipeIdDinner;
}
export class MealPlanDTO {
	id?: any;
	planName: string;
	lastUpdate: any;
	monday: MealPlanItemDTO[] = [new MealPlanItemDTO(),new MealPlanItemDTO(),new MealPlanItemDTO()];
	tuesday: MealPlanItemDTO[] = [new MealPlanItemDTO(),new MealPlanItemDTO(),new MealPlanItemDTO()];
	wednesday: MealPlanItemDTO[] = [new MealPlanItemDTO(),new MealPlanItemDTO(),new MealPlanItemDTO()];
	thursday: MealPlanItemDTO[] = [new MealPlanItemDTO(),new MealPlanItemDTO(),new MealPlanItemDTO()];
	friday: MealPlanItemDTO[] = [new MealPlanItemDTO(),new MealPlanItemDTO(),new MealPlanItemDTO()];
	saturday: MealPlanItemDTO[] = [new MealPlanItemDTO(),new MealPlanItemDTO(),new MealPlanItemDTO()];
	sunday: MealPlanItemDTO[] = [new MealPlanItemDTO(),new MealPlanItemDTO(),new MealPlanItemDTO()];
}